const parseEnvBoolean = (value, defaultValue = false) => {
  if (value === undefined || value === null || value === '') return defaultValue
  return ['true', '1'].includes(String(value).toLowerCase())
}

const parseEnvBooleanDefaultTrue = (value) => {
  if (value === undefined || value === null || value === '') return true
  return !['false', '0'].includes(String(value).toLowerCase())
}

export default {
  enableSubscriptions: parseEnvBoolean(process.env.VUE_APP_ENABLE_SUBSCRIPTIONS, false),
  enablePaymentGateway: parseEnvBoolean(process.env.VUE_APP_ENABLE_PAYMENT_GATEWAY, false),
  enableSmsOtp: parseEnvBoolean(process.env.VUE_APP_ENABLE_SMS_OTP, false),
  enablePhoneOtpSignup: parseEnvBoolean(process.env.VUE_APP_ENABLE_PHONE_OTP_SIGNUP, false),
  enableHandleIdAuth: parseEnvBoolean(process.env.VUE_APP_ENABLE_HANDLE_ID_AUTH, false),
  skipRecaptcha: parseEnvBoolean(process.env.VUE_APP_SKIP_RECAPTCHA, false),
  // Set VUE_APP_ENABLE_ADMIN_INBOX=false to hide the admin notification inbox without removing code.
  enableAdminInbox: parseEnvBooleanDefaultTrue(process.env.VUE_APP_ENABLE_ADMIN_INBOX)
}
